module.exports = __webpack_public_path__ + "img/ic-nolocation.fcf21cf7.svg";